import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {push} from 'react-router-redux';
import { createSelector } from 'reselect';
import { Tab, TabBar } from 'rmwc/Tabs';

import * as styles from '../../../styles';
import PaginatedContainer from '../../../paginator/paginated_container';
import filtersSelectorGenerator from '../../students/filters';
import { setSelectedItems } from '../../tree/actions';
import { host_v2 } from '../../../utilities/requests';

export default class ConsolidateReport extends React.PureComponent {

    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static tabToType(tab) {
        switch (tab) {
            case 0:
                return 'student';
            case 1:
                return 'school';
            case 2:
                return 'city';
            case 3:
                return 'region';
            case 4:
                return 'global';
            default:
                return null;
        }
    }
    state = { currentTab: 0 }

    listFieldsSelector = createSelector(
        [
            (_, state) => state.currentTab,
            context => context.user.id,
        ],
        currentTab => [
            ...this.context.user.hasPerm('examination.reports')
                ? [{ field: 'id', label: window.gettext('ID') }]
                : [],
            {
                field: item =>item?.rank?.global_ ? item?.rank?.global_.persian() : "-",
                label: window.gettext('Rank'),
                sort: '.rank.category.all.global',
            },
            {
                field: item => `${item?.firstname} ${item?.lastname}`,
                label: window.gettext('Name'),
                sort: 'name',
            },

            {
                field: item => this.context.user.hasPerm('admin') ?
                    <span> {item?.school?.name ?? "-"} </span>
                    : null,
                label: "مدرسه",
            },
            {
                field: item => `${item?.username?.persian() ?? "-"}`,
                label: window.gettext('username') ,
                sort:  'username',
            },
            {
                field: item => item.score ? item.score.toPercent().persian(true) : "-",
                label: window.gettext('Score'),
                sort: `.score.category.all.global`,
            },
            {
                field: item => item.taraz ? item.taraz.toFixed().persian() : "-",
                label: window.gettext('Taraz'),
                sort: '.taraz.category.all.global',
            },
            ..._.map(this.props.examination.materials, (material , index) => ({
                fields:item => [
                    ()=> item?.materials?.[material.id].score ? item?.materials?.[material?.id]?.score?.toPercent().persian(): "-" ,
                    ()=> item?.materials?.[material.id]?.rank?.global_ ? item.materials?.[material?.id]?.rank?.global_.persian() : "-" ,
                    ()=> item?.materials?.[material.id]?.taraz ? item.materials?.[material?.id]?.taraz.toFixed().persian() : "-" ,
                 ], 
                label: material.title,
                sort: `.rank.material.${material.id}.global`,
                labels: [
                    {
                        label: window.gettext('Score'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                    {
                        label: window.gettext('Rank'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                    {
                        label: window.gettext('Taraz'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                ],
            })),
        ],
    )
    excel(){ 
        var token = this.context.store.getState().get('application').get('token'); 
        var auth =token.get('accessToken');
        var url = host_v2 + "/ExportExcel/PublicReport?authToken=" + auth + "&examId="+ this.props.examination.id; 
        window.open(url, '_blank');
    }
    studentsFiltersSelector = filtersSelectorGenerator()

    filtersSelector = createSelector.bind(this)(
        [
            (store, props) => props.examination.id,
            store => this.studentsFiltersSelector(store),
            (_, __, state) => state.currentTab,
        ],
        (examination, studentsFilters, currentTab) => [
            { field: 'examination', value: examination }, //ok
            { field: 'entity_type', value: ConsolidateReport.tabToType(currentTab) }, //ok
            { field: 'group_type', value: 'null' },
            ..._.filter(
                studentsFilters,
                filter => {
                    if (ConsolidateReport.tabToType(currentTab) === 'region') {
                        return !_.includes(['region', 'city', 'school'], filter.field);
                    }
                    else if (ConsolidateReport.tabToType(currentTab) === 'city') {
                        return !_.includes(['city', 'school', 'grade'], filter.field);
                    }
                    else if (ConsolidateReport.tabToType(currentTab) === 'school') {
                        return !_.includes(['school', 'grade'], filter.field);
                    }
                    else{
                        return !_.includes(['hasBook', 'hasExam','grade'], filter.field);
                    }
                },
            ),
        ],
    )

    sortsSelector = createSelector(
        [
            (_, state) => state.currentTab,
            props => props.examination.id,
        ],
        currentTab => [
            { name: '.rank.category.all.global', label: window.gettext('Rank') },
            ...ConsolidateReport.tabToType(currentTab) === 'student'
                ? [
                    { name: 'firstname', label: window.gettext('firstname') },
                    { name: 'lastname', label: window.gettext('lastname') },
                ]
                : [
                    { name: 'name', label: window.gettext('Name') },
                ],
            {
                // name: `.${ConsolidateReport.tabToType(currentTab) === 'student' ? 'score' : 'average'}.category.all.global`,
                name:".score.category.all.global",
                label: window.gettext('Score'),
            },
            {
                // name: `.${ConsolidateReport.tabToType(currentTab) === 'student' ? 'score' : 'average'}.category.all.global`,
                name:".taraz.category.all.global",
                label: window.gettext('Taraz'),
            },
            ..._.map(
                this.props.examination.materials,
                material => ({
                    name: `.rank.material.${material.id}.global`,
                    label: material.title,
                }),
            ),
        ],
    )

    render() {
        const userRole = this.context.user.hasPerm('admin')
        return <div style={{
            ..._.pickBy(styles.box, (_, key) => key != 'padding'),
            marginTop: '1em',
            marginBottom: '1em',
            overflowX: 'scroll',
            paddingTop: '.5em',
            paddingLeft: '1em',
            paddingRight: '1em',
        }}>
            <button
                style={{
                    ...styles.defaultButton,
                    padding: '.5em',
                    boxSizing: 'border-box',
                }}
                // onClick={()=>this.excel()}
            >خروجی اکسل
            </button>
            <TabBar
                activeTabIndex={this.state.currentTab}
                onChange={({ target: { value } }) => this.setState({ currentTab: value })}>
                <Tab>{window.gettext('Student')}</Tab>
                {userRole && <Tab>{window.gettext('School')}</Tab>}
                {userRole && <Tab>{window.gettext('City')}</Tab>}
                {userRole && <Tab>{window.gettext('Region')}</Tab>}
            </TabBar>
            <PaginatedContainer
                pubreport={!userRole}
                sidebar={userRole}
                store={this.props.store.get('paginator')}
                resource='consolidated_report'
                tooltip={null}
                style={this.style}
                events={{onClick: async item => {
                    if (this.state.currentTab === 0)
                        this.context.store.dispatch(push(
                            this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            ) + item.id + '/',
                        ));
                }}}
                title={this.props.reportType==="schoolManger" ? "کارنامه مدیر" : "کارنامه تلفیقی"}
                selectable
                listFields={this.listFieldsSelector(this.context, this.state)}
                filters={this.filtersSelector(this.props.store, this.props, this.state)}
                sorts={this.sortsSelector(this.props, this.state)}
                pageSize={30}
            />

        </div>
    }

}